<template>
    <div class="app">
        <!-- <hearder1 @BookTypes="changeBookTypes"></hearder1> -->
        <l-header></l-header>
        <div class="main" :style="{'background-color':$route.path!='/mall/booking'?'#F2F2F2':none}">
            <slot></slot>
        </div>
        <l-footer></l-footer>

    </div>
</template>
<style type="text/css">




</style>
<script type="text/javascript">
    import header from './header'
    import categorys from 'utils/categorys.js'
    import footer from './footer'
    import hearder1 from './hearder1'
    import utils from 'utils';
    export default {
        data() {
            return {
                // BookType: categorys.types.BookingType.OnBusiness
            }
        },
        mounted() {

        },
        computed: {

        },
        methods: {
            // changeBookTypes(value) {
            //     this.BookType = value
            // }
        },
        components: {
            // hearder1,
            'l-header': header,
            'l-footer': footer
        }
    }

</script>



// WEBPACK FOOTER //
// layout.vue?6c1d072a